module.exports = __webpack_public_path__ + "img/暂无等级成长记录@2x.c513bcb5.png";